__turbopack_context__.v({
  "effectBox": "EffectBox-module__HuOwpq__effectBox",
  "inherit": "EffectBox-module__HuOwpq__inherit",
  "orbit": "EffectBox-module__HuOwpq__orbit",
});
